import React, { useState, useEffect } from 'react';
import DataTable from '../../interfaccia/DataTableBase';

function TabGiacenze({prodotto}) {

    const [rows, setRows] = useState(
        prodotto
      )
    
      useEffect(() => {
        setRows(prodotto)
      }, [prodotto]);

      const columns = [
        {
            selector: row => row['taglia'],
            name: prodotto[0].gruppoTaglia,
            sortable: false,
            hide: false,
            reorder: false,
            width: "130px",
            compact: false
        },
        {
            selector: row => row['giacenzaJS'],
            name: "JOLLY",
            sortable: false,
            hide: false,
            reorder: false,
            width: "70px",
            compact: true,
            cell: (row) => {
                if (row['impegnatoJS'] !== 0) {
                  return (<div className="rowitem">
                    <span>{row['giacenzaJS']}<span className='red'>(-{row['impegnatoJS']})</span></span>
                  </div>)
                } else {
                  return <div className="rowitem">{row['giacenzaJS']}</div>
                }
        
            }
        },
        {
            selector: row => row['giacenzaPN'],
            name: "PRATO",
            sortable: false,
            hide: false,
            reorder: false,
            width: "70px",
            compact: true,
            cell: (row) => {
                if (row['impegnatoPN'] !== 0) {
                  return (<div className="rowitem">
                    <span>{row['giacenzaPN']}<span className='red'>(-{row['impegnatoPN']})</span></span>
                  </div>)
                } else {
                  return <div className="rowitem">{row['giacenzaPN']}</div>
                }
        
            }
        },
        {
            selector: row => row['giacenzaVM'],
            name: "VILLANOVA",
            sortable: false,
            hide: false,
            reorder: false,
            width: "70px",
            compact: true,
            cell: (row) => {
                if (row['impegnatoVM'] !== 0) {
                  return (<div className="rowitem">
                    <span>{row['giacenzaVM']}<span className='red'>(-{row['impegnatoVM']})</span></span>
                  </div>)
                } else {
                  return <div className="rowitem">{row['giacenzaVM']}</div>
                }
        
            }
        },
        {
            selector: row => row['giacenzaCH'],
            name: "CHERASCO",
            sortable: false,
            hide: false,
            reorder: false,
            width: "70px",
            compact: true,
            cell: (row) => {
                if (row['impegnatoCH'] !== 0) {
                  return (<div className="rowitem">
                    <span>{row['giacenzaCH']}<span className='red'>(-{row['impegnatoCH']})</span></span>
                  </div>)
                } else {
                  return <div className="rowitem">{row['giacenzaCH']}</div>
                }
        
            }
        },
        {
            selector: row => row['ean'],
            name: "EAN",
            sortable: false,
            hide: false,
            reorder: false,
            width: "150px",
            compact: false
        }
      ];

    return(
        <div className='nonSelezionabile '>
            <div className='mt3 f5 ttu b tc'>Giacenze</div>
            <DataTable
                data={rows}
                columns={columns}
                fixedHeader={false}
                fixedHeaderScrollHeight={"100px"}
                striped={false}
                progressPending={false}
                noDataComponent={<h3 className='ma5 pa5'>Nessun articolo risponde alla tua ricerca.</h3>}
                progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
                pagination={false}
            />
            {/* <div className='db divScrollabileOrizzontale'>
            <div className='flex mt4 '>
                        <span className='b w4 mr3'>{prodotto[0].gruppoTaglia}</span>
                        <span className='b w3 mr3'>JOLLY</span>
                        <span className='b w3 mr3'>PRATO</span>
                        <span className='b w3 mr3'>VILLANOVA</span>
                        <span className='b w3 mr3'>CHERASCO</span>
                        <span className='b w5 mr3'>EAN</span>
            </div>
            {prodotto.map(prod => {
                return(
                    <div className='flex mt3'>
                        <span className=' w4 mr3'>{prod.taglia}</span>
                        <span className=' w3 mr3'>{prod.giacenzaJS}</span>
                        <span className=' w3 mr3'>{prod.giacenzaPN}</span>
                        <span className=' w3 mr3'>{prod.giacenzaVM}</span>
                        <span className=' w3 mr3'>{prod.giacenzaCH}</span>
                        <span className=' w5 mr3'>{prod.ean}</span>
                    </div>
                )
            })}
            </div> */}
        </div>
    )
}

export default TabGiacenze;